<template >
  <div class="pdf-paginator">
    <v-card class="d-flex justify-center align-center paginator-card" height="50" max-width="260">
      <v-btn icon color="primary" @click="goFirst">
        <v-icon v-once>mdi-chevron-double-left</v-icon>
      </v-btn>
      <v-btn icon color="primary" @click="decrement">
        <v-icon v-once>mdi-chevron-left</v-icon>
      </v-btn>
      <v-text-field v-model="auxPage" @change="calculatePage" color="primary" hide-details type="number"
        class="numberInput ma-0 ml-3 mr-2 pa-0 shrink" dense />
      <span class="mb-0 mr-3 pb-0">/ {{ pageCount }}</span>
      <v-btn icon color="primary" @click="increment">
        <v-icon v-once>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn icon color="primary" @click="goLast">
        <v-icon v-once>mdi-chevron-double-right</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "PDFPaginator",

  props: {
    pageCount: Number,
  },

  data() {
    return {
      auxPage: 1,
    };
  },

  mounted() {
    this.actualPage = 1;
    this.auxPage = this.actualPage;
  },

  methods: {
    ...mapActions({ setCurrentPage: 'setCurrentPage' }),
    pageChanged() {
      this.$emit("page-changed", this.auxPage);
      this.setCurrentPage(this.auxPage)
    },
    calculatePage() {
      if (this.auxPage > this.pageCount || this.auxPage < 1) {
        this.auxPage = this.actualPage;
      } else {
        this.actualPage = this.auxPage;
      }
      this.pageChanged();
    },
    goFirst() {
      this.auxPage = 1;
      this.calculatePage();
    },
    increment() {
      this.auxPage++;
      this.calculatePage();
    },
    decrement() {
      this.auxPage--;
      this.calculatePage();
    },
    goLast() {
      this.auxPage = this.pageCount;
      this.calculatePage();
    },
  },
};
</script>

<style scoped>
.pdf-paginator {
  color: transparent;
  font-weight: bold;
}

.pdf-paginator>>>input {
  width: 2em;
  padding: 0.3em;
  text-align: center;
}

.paginator-card {
  background-color: white;
  opacity: 0.7;
}

.pdf-paginator>>>input[type='number'] {
  -moz-appearance: textfield;
}

.pdf-paginator>>>input::-webkit-outer-spin-button,
.pdf-paginator>>>input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
